<template lang="pug">
    v-dialog(
        v-model='dialog'
        fullscreen
        scrollable
        transition='dialog-bottom-transition'
    )
        template(v-slot:activator='{ on, attrs }')
            v-btn.volie-color-blue(
                v-bind='attrs'
                v-on='on'
                dark
                ripple
                rounded
                outlined
                style="border-color: var(--volie-blue);"
            )
                template(v-if='windowWidth >= 1680')
                    | Appointments Made Today: {{ (appointmentsToday || 0) | number }}
                template(v-else)
                    v-icon mdi-calendar
                    span
                        | : {{ (appointmentsToday || 0) | number }}

        v-card
            v-toolbar
                v-btn(icon @click='closeDialog();')
                    v-icon mdi-close
                v-toolbar-title Today's Appointments Log
                v-spacer

            v-card-text.pa-md-4.brown.lighten-5(style="height: 100vh;")
                .text-center(v-if="isLoading")
                    v-progress-circular(
                        :size='100'
                        :width='10'
                        color='var(--volie-blue)'
                        indeterminate
                        style="margin-top: 100px;"
                    )

                BaseCustomerProfile(
                    v-else-if="validCustomer"
                    :customer-id="customerID"
                    :exit="exitCustomerProfile"
                    includeComponentInHeight
                )

                v-card(v-else)
                    v-card-text
                        div.px-4.d-flex.justify-space-between.align-center
                            div 
                                v-btn(
                                    icon
                                    @click='updateDate(-1)'
                                ).mr-2
                                    v-icon mdi-chevron-left
                                | {{ searchDateString }}
                                v-btn(
                                    icon
                                    @click='updateDate(1)'
                                )
                                    v-icon mdi-chevron-right
                            div 
                                v-btn(
                                    color='primary'
                                    dark
                                    :outlined='filterBy !== "created_at"'
                                    @click='filterBy = "created_at"; searchAppointments()'
                                ).mr-2
                                    | Created Today
                                v-btn(
                                    color='primary'
                                    dark
                                    :outlined='filterBy !== "appointment_datetime"'
                                    @click='filterBy = "appointment_datetime"; searchAppointments()'
                                )
                                    | Appointments Today
                        v-simple-table.ma-md-4.table-x-scroll(v-if="validAppointments")
                            template(v-slot:default)
                                thead
                                    tr
                                        th
                                        template(v-if="filterBy === 'appointment_datetime'")
                                            th Appt Date / Time
                                            th Created
                                        template(v-else) 
                                            th Created
                                            th Appt Date / Time
                                        th Organization
                                        th Customer
                                        th Contact
                                        th Status
                                        th Showed
                                        th Vehicle
                                        th Vehicle VIN
                                        th Campaign
                                        th Appointment Type
                                        th
                                tbody
                                    tr(
                                        v-for='(appt, idx) in appointments'
                                        :key='appt.appointment_id'
                                    )
                                        td.no-wrap.xs-xs-width {{ idx + 1 | number }}
                                        td.no-wrap.sm-width
                                            template(v-if="filterBy === 'appointment_datetime'")
                                                | {{ appt.friendly_appointment_datetime }}
                                            template(v-else)
                                                | {{ appt.friendly_created_at }}
                                        td.no-wrap.sm-width
                                            template(v-if="filterBy === 'appointment_datetime'")
                                                | {{ appt.friendly_created_at }}
                                            template(v-else)
                                                | {{ appt.friendly_appointment_datetime }}
                                        td.no-wrap.sm-width
                                            v-tooltip(top)
                                                template(v-slot:activator='{ on, attrs }')
                                                    span(v-bind="attrs" v-on="on" role="text")
                                                        | {{ appt.organization_name | str_limit(35) }}
                                                span
                                                    | {{ appt.organization_name }}
                                        td.no-wrap.sm-width
                                            v-tooltip(bottom v-if="appt.customer_id > 0")
                                                template(v-slot:activator='{ on, attrs }')
                                                    v-btn.mr-2(
                                                        outlined
                                                        fab
                                                        x-small
                                                        color="success"
                                                        @click="viewProfile(appt.customer_id);"
                                                        v-bind='attrs'
                                                        v-on='on'
                                                    )
                                                        v-icon
                                                            | mdi-eye
                                                span View profile

                                            template(v-if="appt.customer_name")
                                                v-tooltip(top)
                                                    template(v-slot:activator='{ on, attrs }')
                                                        span(v-bind="attrs" v-on="on" role="text")
                                                            | {{ appt.customer_name | str_limit(35) }}
                                                    span
                                                        | {{ appt.customer_name }}
                                            template(v-else) ---
                                        td.no-wrap.sm-width
                                            v-tooltip(top)
                                                template(v-slot:activator='{ on, attrs }')
                                                    v-btn(
                                                        :disabled="callsDisabled"
                                                        icon
                                                        small 
                                                        color="primary" 
                                                        dark 
                                                        @click='handleInitiateCall(appt)'         
                                                        v-bind="attrs"
                                                        v-on="on"
                                                    )
                                                        v-icon mdi-phone-outgoing
                                                span Call Customer

                                            v-tooltip(top v-if="appt.manaul_call_after_conference_id > 0")
                                                template(v-slot:activator='{ on, attrs }')
                                                    v-btn(
                                                        icon
                                                        small 
                                                        color="success" 
                                                        dark 
                                                        v-bind="attrs"
                                                        v-on="on"
                                                    )
                                                        v-icon mdi-check
                                                span Manual called by {{ appt.manaul_call_after_agent_name }} at {{ appt.manaul_call_after_created_at }}

                                        td.no-wrap.sm-width
                                            span(v-if="appt.status" :class="appt.status | statusClassMatcher") {{ appt.status | titleize }}
                                            template(v-else) ---
                                            span.ml-2.caption.grey--text(v-if="appt.is_tracker_credited === false")
                                                | Not credited
                                                template(v-if="appt.original_agent_name")  — credited to {{ appt.original_agent_name }}
                                        td.no-wrap.sm-width
                                            template(v-if="appt.status === 'canceled' || appt.status === 'rescheduled'") ---
                                            template(v-else)
                                                template(v-if="appt.is_show")
                                                    v-tooltip(top)
                                                        template(v-slot:activator='{ on, attrs }')
                                                            span(v-bind="attrs" v-on="on" role="text")
                                                                v-icon.green--text mdi-check
                                                        span
                                                            | Yes
                                                template(v-else)
                                                    v-tooltip(top)
                                                        template(v-slot:activator='{ on, attrs }')
                                                            span(v-bind="attrs" v-on="on" role="text")
                                                                v-icon.error--text mdi-close
                                                        span
                                                            | No
                                        td.no-wrap.sm-width
                                            template(v-if="appt.vehicle_year || appt.vehicle_make || appt.vehicle_model")
                                                StrLimitTooltipText(:text="vehicleName(appt.vehicle_year, appt.vehicle_make, appt.vehicle_model)" :char-limit="50" is-html)
                                            template(v-else) ---
                                        td.no-wrap.sm-width
                                            template(v-if="appt.vin")
                                                CopyableText(:text="appt.vin")
                                            template(v-else) ---
                                        td.no-wrap.sm-width
                                            template(v-if="appt.campaign_name")
                                                StrLimitTooltipText(:text="appt.campaign_name" :char-limit="35")
                                            template(v-else) ---
                                        td.no-wrap.sm-width
                                            template(v-if="appt.appointment_type_name") {{ appt.appointment_type_name }}
                                            template(v-else) ---
                                    tr(v-if="showMore")
                                        td.text-center(colspan='10')
                                            v-btn.volie-color-blue(link text ripple small @click="handleShowMore();")
                                                | Show more

                        v-alert.mx-lg-auto.mt-md-4.mb-md-4(type="warning" v-else)
                            | Unable to find any appointments

</template>

<script lang="ts">
    import Vue from 'vue';
    import VolieState  from "@/store";

    // Components
    import BaseCustomerProfile from '@/components/customers/base_customer_profile.vue';
    import CopyableText from '@/components/shared/copyable_text.vue';
    import StrLimitTooltipText from "@/components/shared/str_limit_tooltip_text.vue";

    // Data
    import { GetAppointmentDashboardAppointments } from "@/data";

    // Helper
    import { formatVehicleName } from "@/helpers/name";

    export default Vue.extend({
        data() {
            return {
                appointments: [],
                customerID: null,
                dialog: false,
                filterBy: "created_at",
                isLoading: false,
                lastConferenceID: null,
                limit: 100,
                offset: 0,
                searchDialog: false,
                searchObj: {
                    date: new Date(), // default today
                    status: null,
                },
                showMore: false,
                windowWidth: 0,
            }
        },
        methods: {
            closeDialog() {
                this.searchDialog = false;
                this.dialog = false;
            },
            dateString() {
                return this.searchObj?.date?.toLocaleDateString();
            },
            exitCustomerProfile() {
                this.customerID = null;
            },
            getAppointments() {

                if (!this.validCurrentUser) {
                    return;
                }

                // Default to current date, but if they've moved left or right, use that date
                const startEnd = this.dateString();

                // Init
                const options = {
                    day_log_attribution:    true,
                    end_date:               startEnd,
                    filter_by:              this.filterBy,
                    limit:                  this.limit,
                    offset:                 this.offset,
                    status:                 this.searchObj.status || null,
                    start_date:             startEnd,
                    user_id:                this.currentUser.user_id,
                    include_appointments_without_type: true,
                }

                GetAppointmentDashboardAppointments(options).then((response) => {
                    if (response?.Data?.appointments?.length > 0) {
                        if (!!this.appointments && this.appointments.length > 0) {
                            this.appointments = this.appointments.concat(response.Data.appointments);
                        } else {
                            this.appointments = response.Data.appointments;
                        }
                        
                        // Get last record and set ID - not using last id, because the existing appointment dashboard get call is not sorted by ID
                        // this.lastAppointmentID = this.appointments[this.appointments.length - 1]?.appointment_id;
                    }
                    
                    this.showMore = response?.Data?.appointments?.length === this.limit;
                    this.isLoading = false;
                });
            },
            handleInitiateCall(appointment) {
                const payload = {
                    appointment_id: appointment.appointment_id,
                    conference_id: null,
                }
                VolieState.setTopNavManualCall(payload);
                this.closeDialog();
            },
            handleWindowResize() {
                if (window?.innerWidth > 0) {
                    this.windowWidth = window.innerWidth;
                    return;
                }

                this.windowWidth = 0;
            },
            handleShowMore() {
                this.offset += this.limit;
                this.getAppointments();
            },
            reinitSearch() {
                this.resetSearchObj();
                this.searchAppointments();
            },
            resetSearchObj() {
                this.offset = 0;
                this.filterBy = "created_at";
                this.searchObj = {
                    date: new Date(), // default today
                    status: null,
                }
            },
            searchAppointments() {
                this.isLoading = true;
                this.appointments = [];
                this.getAppointments();
            },
            updateDate(change) {

                // Create a new date object to avoid mutating the original
                const newDate = new Date(this.searchObj.date);
                // Add or subtract days based on change parameter
                // If change is -1, go back a day; if change is 1, go forward a day
                newDate.setDate(newDate.getDate() + change);
                // Update the date in searchObj
                this.searchObj.date = newDate;

                // Search
                this.searchAppointments();
            },
            vehicleName(year, make, model) {
                return formatVehicleName(year, make, model)
            },
            viewProfile(customerID) {
                this.customerID = customerID;
            },
        },
        computed: {
            callsDisabled() {
                return this.$route.path !== '/communication_center';
            },
            currentUser() {
                return VolieState.currentUser();
            },
            searchDateString() {
                return this.searchObj.date.toLocaleDateString();
            },
            validAppointments() {
                return this.appointments?.length > 0;
            },
            validCurrentUser() {
                return this.currentUser?.user_id > 0;
            },
            validCustomer() {
                return this.customerID > 0;
            },
        },
        components: {
            BaseCustomerProfile,
            CopyableText,
            StrLimitTooltipText,
        },
        props: {
            appointmentsToday: Number, 
        },
        watch: {
            dialog() {
                // Load only as dialog is opened
                if (this.dialog) {
                    this.reinitSearch();
                }
            },
        },
        created() {
            this.handleWindowResize();
            window.addEventListener('resize', this.handleWindowResize);
        },
        destroyed() {
            window.removeEventListener('resize', this.handleWindowResize);
        },
    });
</script>

<style lang="scss" scoped>
</style>
